import { createAction, props } from '@ngrx/store';

import {
  ClientContactCreate,
  ClientCreate,
} from '@lockton-apps/shared/interfaces';

import { ClientNewActionTypes } from './types';

export const init = createAction(
  ClientNewActionTypes.Init,
  props<{ steps: Array<number> }>()
);

export const clientDataAdded = createAction(
  ClientNewActionTypes.ClientDataAdded,
  props<{
    client: ClientCreate;
    contact: ClientContactCreate;
    subClients: ClientCreate[];
  }>()
);

export const nextStepClicked = createAction(
  ClientNewActionTypes.NextStepClicked
);

export const stepClicked = createAction(
  ClientNewActionTypes.StepClicked,
  props<{ step: number }>()
);

export const stepsChanged = createAction(
  ClientNewActionTypes.StepsChanged,
  props<{ steps: Array<number> }>()
);
